export const emailSourceOptions = [
  { value: '', label: '-- Auto (first connected) --' },
];

export const defaultEmailConnection = {
  host: '',
  port: '587',
  encryption: 'tls',
  username: '',
  password: '',
  fromName: '',
  fromEmail: '',
};

export const defaultWhatsAppConnection = {
  phoneNumber: '',
  apiKey: '',
  businessName: '',
};

export const defaultGlobalConfig = {
  emailConnected: false,
  emailEnabled: false,
  emailSource: '',
  whatsappConnected: false,
  whatsappEnabled: false,
  whatsappPhone: '',
  defaultSendTime: '09:00',
  adminEmail: '',
  sendInvoiceCopyToOwner: false,
  autoSendOnSave: false,
  smtp: { ...defaultEmailConnection },
  whatsapp: { ...defaultWhatsAppConnection },
};

export const notificationHistory = [];

export const statusFilterOptions = ['All', 'Pending', 'Sent', 'Failed'];
export const channelFilterOptions = ['All', 'Email', 'WhatsApp', 'In-App'];
export const typeFilterOptions = [
  { value: 'All', label: 'All' },
  { value: 'subscription_expiring', label: 'Subscription Expiring' },
  { value: 'subscription_expired', label: 'Subscription Expired' },
  { value: 'payment_due', label: 'Payment Pending' },
  { value: 'renewal_thanks', label: 'Renewal Thank You' },
  { value: 'trial_ending', label: 'Trial Ending' },
  { value: 'test_email', label: 'Test Email' },
];

/** Gym admin subscription reminders (Owner panel) */
export const gymReminders = [
  {
    id: 'subscription_expiring',
    label: 'Subscription Expiring',
    enabled: false,
    email: true,
    daysBefore: 7,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: true,
    template:
      'Hi {gym_admin}, your {gym_name} subscription ({plan_name}) expires on {expiry_date}. Renew today to avoid interruption!',
  },
  {
    id: 'subscription_expired',
    label: 'Subscription Expired',
    enabled: false,
    email: true,
    daysBefore: 0,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: false,
    template: 'Hi {gym_admin}, the {gym_name} subscription has expired. Renew now to regain access.',
  },
  {
    id: 'payment_due',
    label: 'Payment Pending',
    enabled: false,
    email: true,
    daysBefore: 3,
    sendTime: '10:00',
    inAppLog: true,
    hasDaysBefore: true,
    template: 'Hi {gym_admin}, the subscription payment of {amount} for {gym_name} is pending. Please settle to stay active.',
  },
  {
    id: 'trial_ending',
    label: 'Trial Ending',
    enabled: false,
    email: true,
    daysBefore: 3,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: true,
    template: 'Hi {gym_admin}, your {gym_name} free trial ends on {expiry_date}. Upgrade to keep your data and features.',
  },
  {
    id: 'renewal_thanks',
    label: 'Renewal Thank You',
    enabled: false,
    email: true,
    daysBefore: 0,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: false,
    template: 'Thank you {gym_admin} for renewing the {gym_name} subscription. We appreciate your continued partnership!',
  },
];

export { formatPlatformPrice as formatPrice } from '../../../utils/platformMoney';
